/* eslint-disable camelcase */
/* eslint-disable class-methods-use-this */
/* eslint-disable eqeqeq */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/sort-comp */
/* eslint-disable react/prop-types */

import { loadLegacyHistoryUser } from 'controllers/legacyHistorySession';
import { ToastContainer } from '@postscript/components';
import Profile from 'components/account/AccountView/users/profile/Profile';
import { FEATURE_KEYS } from 'components/billing/common/constants';
import BillingBanners from 'components/billing/common/prompts/BillingBanners';
import RacApprovedConfirmation from 'components/billing/common/prompts/RacApprovedConfirmation';
import Plans from 'components/billing/modules/selfMigrate/Plans';
import GorgiasIntegrationV2 from 'components/integrations/GorgiasIntegrationV2';
import LegacyHistoryExpired from 'components/invisible/LegacyHistoryExpired';
import Loading from 'components/invisible/Loading';
import LookerDashboard from 'components/looker/LookerDashboard';
import DataSyncingBanner from 'components/notifications/DataSyncingBanner';
import TFNInvalidationBanner from 'components/notifications/TFNInvalidationBanner';
import TFNVerificationStatusBanner from 'components/notifications/TFNVerificationStatusBanner';
import OmniDashboards from 'components/omni/OmniDashboards';
import OmniReportingGate from 'components/omni/OmniReportingGate';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { renderPrefixRedirect } from 'components/acquisitions/utils/renderRedirect';
import { ROUTE_BACK_IN_STOCK } from 'components/backInStock/constants';
import { ROUTE_EMBEDDED_FORMS } from 'components/embeddedForms/constants';
import { ROUTE_LANDING_PAGES } from 'components/landingPages/constants';
import { LEGACY_POPUPS_PATH } from 'components/popups-legacy/constants/routes';
import {
  BLOCK_POPUP_PATHS,
  LEGACY_BLOCK_POPUPS_LIST_PATH,
} from 'components/popups/constants';
import { RouteGuard } from 'components/routing/RouteGuard';
import RestrictedPage from 'components/shared/RestrictedPage';
import { ROUTE_SAVED_TARGETING_PROFILES } from 'components/targetingProfiles/constants';
import { LabsFeatureContext } from 'controllers/contexts/labsFeatures';
import { usePreviousLocationTracker } from 'hooks/usePreviousLocation';
import { SentryContext } from 'hooks/useSentry';
import useShopData from 'hooks/useShopData';
import {
  EntitlementsProvider,
  useEntitlements,
} from 'providers/entitlements/EntitlementsProvider';
import { EntitlementKeys } from 'providers/entitlements/types';
import React, { Component, Suspense, useEffect } from 'react';
import 'react-dates/initialize';
import ReactGA from 'react-ga';
import { Redirect, Route, Router, Switch } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import {
  OMNI_SANDBOX,
  OMNI_TRENDS,
  USAGE_BILLING_ENABLED,
} from './components/admin/utils/feature-flags';
import ResetForgottenPassword from './components/authentication/ResetForgottenPassword';
import ResetPasswordInvisible from './components/authentication/ResetPasswordInvisible';
import ResetPasswordRequest from './components/authentication/ResetPasswordRequest';
import ScopesUpdateBanner from './components/authentication/ScopesUpdateBanner';
import CallForwardingBanner from './components/billing/common/prompts/CallForwardingBanner';
import LegacyPastDueStatusBanner from './components/billing/common/prompts/LegacyPastDueStatusBanner';
import { UsageBillingContext } from './components/billing/context/usageBilling';
import GlobalAuthenticatedContexts from './components/Global/GlobalAuthenticatedContexts';
import KlaviyoOAuthMigrationBanner from './components/integrations/KlaviyoOAuthMigrationBanner';
import KlaviyoScopesUpdateBanner from './components/integrations/KlaviyoScopesUpdateBanner';
import AppShell from './components/layout/AppShell';
import LegacyGlobalBannerList from './components/LegacyGlobalBanners/LegacyGlobalBannerList';
import AppModal from './components/navigation/AppModal';
import UpsellModal from './components/navigation/UpsellModal';
import DelightedRatingComponent from './components/notifications/DelightedRatingComponent';
import OnboardingStatusBanner from './components/pspay/OnboardingStatusBanner';
import ReferralRedirect from './components/referrals/ReferralRedirect';
import SMSSalesMerchantRoutes from './components/sales/MerchantRoutes';
import { SALES_ROUTE_PREFIX } from './components/sales/Routes';
import './config/styles';
import { HistoryContext, UserContext } from './controllers/contexts';
import { useFeatureFlags } from './controllers/contexts/featureFlags';
import { LegacyGlobalNotificationsProvider } from './controllers/contexts/legacyGlobalNotifications';
import { PopupsProvider } from './controllers/contexts/popups';
import { PsPayProvider } from './controllers/contexts/pspay';
import { ReferralsProvider } from './controllers/contexts/referrals';
import Events from './controllers/events';
import Requests from './controllers/network/network_requests';
import './controllers/prototypes';
import { withAuth } from './hooks/useAuth';
import { feedbackLoopRedirect, ShopperStatusProvider } from './providers';
import { base } from './themes/themes';
import {
  createAppHistory,
  planFirstMe,
  sameOriginHref,
  sameOriginPath,
  swroToHold,
  withoutSwro,
} from './utils/adminHost';
import { ENV, getHostEnv, IS_ADMIN_HOST } from './utils/envVars';
import { lazyLoadWithChunkRefresh } from './utils/lazyLoadWithChunkRefresh';
import { initSentry } from './utils/sentry';

const AppInit = React.lazy(() =>
  lazyLoadWithChunkRefresh(
    () => import('./components/invisible/AppInit'),
    'AppInit',
  ),
);
const OnboardingRoutes = React.lazy(() =>
  lazyLoadWithChunkRefresh(
    () => import('./components/onboarding/Routes'),
    'OnboardingRoutes',
  ),
);
const LegacyHistoryLogin = React.lazy(() =>
  lazyLoadWithChunkRefresh(
    () => import('./components/invisible/LegacyHistoryLogin'),
    'LegacyHistoryLogin',
  ),
);

const AppAuth = React.lazy(() =>
  lazyLoadWithChunkRefresh(
    () => import('./components/invisible/AppAuth'),
    'AppAuth',
  ),
);
const RegisterForm = React.lazy(() =>
  lazyLoadWithChunkRefresh(
    () => import('./components/authentication/RegisterUser'),
    'RegisterForm',
  ),
);
const LoginUserShopify = React.lazy(() =>
  lazyLoadWithChunkRefresh(
    () => import('./components/authentication/LoginUserShopify'),
    'LoginUserShopify',
  ),
);
const LoginForm = React.lazy(() =>
  lazyLoadWithChunkRefresh(
    () => import('./components/authentication/LoginUser'),
    'LoginUser',
  ),
);
const SegmentView = React.lazy(() =>
  lazyLoadWithChunkRefresh(
    () => import('./components/segments/SegmentView'),
    'SegmentView',
  ),
);
const SegmentSubscribersView = React.lazy(() =>
  lazyLoadWithChunkRefresh(
    () => import('./components/segments/subscribers/SegmentSubscribersView'),
    'SegmentSubscribersView',
  ),
);
const SegmentsV2Routes = React.lazy(() =>
  lazyLoadWithChunkRefresh(
    () => import('./components/segments/v2/Routes'),
    'SegmentsV2Routes',
  ),
);
const EmailTemplatesRoutes = React.lazy(() =>
  lazyLoadWithChunkRefresh(
    () => import('./components/emailTemplates/Routes'),
    'EmailTemplatesRoutes',
  ),
);
const KeywordsView = React.lazy(() =>
  lazyLoadWithChunkRefresh(
    () => import('./components/keywords/KeywordsView'),
    'KeywordsView',
  ),
);
const ResponsesView = React.lazy(() =>
  lazyLoadWithChunkRefresh(
    () => import('./components/responses/ResponsesView'),
    'ResponsesView',
  ),
);
const ConversationsView = React.lazy(() =>
  lazyLoadWithChunkRefresh(
    () => import('./components/conversations/ConversationsView'),
    'ConversationsView',
  ),
);
const IdeasView = React.lazy(() =>
  lazyLoadWithChunkRefresh(
    () => import('./components/ideas/IdeasView'),
    'IdeasView',
  ),
);
const IntegrationsView = React.lazy(() =>
  lazyLoadWithChunkRefresh(
    () => import('./components/integrations/IntegrationsView'),
    'IntegrationsView',
  ),
);
const FondueLanding = React.lazy(() =>
  lazyLoadWithChunkRefresh(
    () => import('./components/integrations/FondueLanding'),
    'FondueLanding',
  ),
);
const NotificationsView = React.lazy(() =>
  lazyLoadWithChunkRefresh(
    () => import('./components/notifications/NotificationsView'),
    'NotificationsView',
  ),
);
const AdminRoutes = React.lazy(() =>
  lazyLoadWithChunkRefresh(
    () => import('./components/admin/Routes'),
    'AdminRoutes',
  ),
);
const AccountReviewView = React.lazy(() =>
  lazyLoadWithChunkRefresh(
    () => import('./components/admin/AccountReviewView'),
    'AccountReviewView',
  ),
);
const AIProductConfiguration = React.lazy(() =>
  lazyLoadWithChunkRefresh(
    () =>
      import(
        './components/admin/AIProductConfiguration/AIProductConfiguration'
      ),
    'AIProductConfiguration',
  ),
);
const ShopperPlaygroundPage = React.lazy(() =>
  lazyLoadWithChunkRefresh(
    () => import('./components/admin/ShopperPlayground/ShopperPlaygroundPage'),
    'ShopperPlaygroundPage',
  ),
);
const SuperuserView = React.lazy(() =>
  lazyLoadWithChunkRefresh(
    () => import('./components/admin/superuser'),
    'SuperuserView',
  ),
);
const GrowListView = React.lazy(() =>
  lazyLoadWithChunkRefresh(
    () => import('./components/grow/GrowListView'),
    'GrowListView',
  ),
);
const AnalyticsRoutes = React.lazy(() =>
  lazyLoadWithChunkRefresh(
    () => import('./components/analytics/AnalyticsRoutes'),
    'AnalyticsRoutes',
  ),
);
const AnalyticsShopperTrendsView = React.lazy(() =>
  lazyLoadWithChunkRefresh(
    () =>
      import(
        './components/analytics/AnalyticsShopperTrendsViews/AnalyticsShopperTrendsView'
      ),
    'AnalyticsShopperTrendsView',
  ),
);

const FlowsRoutes = React.lazy(() =>
  lazyLoadWithChunkRefresh(
    () => import('./components/flowBuilder/FlowsRoutes'),
    'FlowsRoutes',
  ),
);
const LegacyRoutes = React.lazy(() =>
  lazyLoadWithChunkRefresh(
    () => import('./components/legacy/LegacyRoutes'),
    'LegacyRoutes',
  ),
);
const BillingRoutes = React.lazy(() =>
  lazyLoadWithChunkRefresh(
    () => import('./components/billing/Routes'),
    'BillingRoutes',
  ),
);
const SubscriberListsRoutes = React.lazy(() =>
  lazyLoadWithChunkRefresh(
    () => import('./components/subscribersLists/components/Routes'),
    'SubscribersRoutes',
  ),
);
const SubscriberListUploadsRoutes = React.lazy(() =>
  lazyLoadWithChunkRefresh(
    () =>
      import(
        './components/subscribersLists/components/SubscriberListUploadsRoutes'
      ),
    'SubscriberListUploadsRoutes',
  ),
);
const BulkSubscriberOperationsRoutes = React.lazy(() =>
  lazyLoadWithChunkRefresh(
    () =>
      import(
        './components/bulkSubscriberOperations/components/BulkSubscriberOperationsRoutes'
      ),
    'BulkSubscriberOperationsRoutes',
  ),
);
const SubscriberPropertyUploadsRoutes = React.lazy(() =>
  lazyLoadWithChunkRefresh(
    () =>
      import(
        './components/subscriberPropertyUploads/components/PropertyUploadsRoutes'
      ),
    'SubscriberPropertyUploadsRoutes',
  ),
);
const BrandRoutes = React.lazy(() =>
  lazyLoadWithChunkRefresh(
    () => import('./components/brand/Routes'),
    'BrandRoutes',
  ),
);
const CashbackRoutes = React.lazy(() =>
  lazyLoadWithChunkRefresh(
    () => import('./components/cashback/Routes'),
    'CashbackRoutes',
  ),
);
const PopupRoutes = React.lazy(() =>
  lazyLoadWithChunkRefresh(
    () => import('./components/popups-legacy/Routes'),
    'PopupRoutes',
  ),
);
const PopupBlockRoutes = React.lazy(() =>
  lazyLoadWithChunkRefresh(
    () => import('./components/popups/Routes'),
    'PopupBlockRoutes',
  ),
);
const BackInStockRoutes = React.lazy(() =>
  lazyLoadWithChunkRefresh(
    () => import('./components/backInStock/Routes'),
    'BackInStockRoutes',
  ),
);
const LandingPagesRoutes = React.lazy(() =>
  lazyLoadWithChunkRefresh(
    () => import('./components/landingPages/Routes'),
    'LandingPagesRoutes',
  ),
);
const EmbeddedFormsRoutes = React.lazy(() =>
  lazyLoadWithChunkRefresh(
    () => import('./components/embeddedForms/Routes'),
    'EmbeddedFormsRoutes',
  ),
);
const TargetingProfilesRoutes = React.lazy(() =>
  lazyLoadWithChunkRefresh(
    () => import('./components/targetingProfiles/Routes'),
    'TargetingProfilesRoutes',
  ),
);
const CheckoutSettingsView = React.lazy(() =>
  lazyLoadWithChunkRefresh(
    () => import('./components/checkout/CheckoutSettingsView'),
    'CheckoutSettingsView',
  ),
);
const AccountView = React.lazy(() =>
  lazyLoadWithChunkRefresh(
    () => import('./components/account/AccountView'),
    'AccountView',
  ),
);
const ContactView = React.lazy(() =>
  lazyLoadWithChunkRefresh(
    () => import('./components/contacts/ContactView'),
    'ContactView',
  ),
);
const DashboardViewEntry = React.lazy(() =>
  lazyLoadWithChunkRefresh(
    () => import('./components/dashboard/DashboardViewEntry'),
    'DashboardViewEntry',
  ),
);
const AutomationsRoutes = React.lazy(() =>
  lazyLoadWithChunkRefresh(
    () => import('./components/automations/Routes'),
    'AutomationsRoutes',
  ),
);
const PsPayRoutes = React.lazy(() =>
  lazyLoadWithChunkRefresh(
    () => import('./components/pspay/Routes'),
    'PsPayRoutes',
  ),
);
const RedirectPage = React.lazy(() =>
  lazyLoadWithChunkRefresh(
    () => import('./components/pspay/RedirectPage/RedirectPage'),
    'RedirectPage',
  ),
);
const CampaignsView = React.lazy(() =>
  lazyLoadWithChunkRefresh(
    () => import('./components/campaigns/CampaignsView'),
    'CampaignsView',
  ),
);
const ReferralsView = React.lazy(() =>
  lazyLoadWithChunkRefresh(
    () => import('./components/referrals/ReferralsView'),
    'ReferralsView',
  ),
);
const RunTemplateView = React.lazy(() =>
  lazyLoadWithChunkRefresh(
    () => import(`./components/GenericTemplates/RunTemplateView`),
    'RunTemplateView',
  ),
);

const SalesRoutes = React.lazy(() =>
  lazyLoadWithChunkRefresh(() => import('./components/sales/Routes')),
);

const ShopData = () => {
  const { data, isLoading } = useShopData();
  useEffect(() => {
    if (data) {
      window.dataLayer.push({
        event: 'gtm data loaded',
        data,
      });
    }
  }, [isLoading]);
  return null;
};

const UpsellModalGate = ({ children, onSuppress }) => {
  const { hasFlag } = useFeatureFlags();
  const suppressed = hasFlag(USAGE_BILLING_ENABLED);

  useEffect(() => {
    if (suppressed && onSuppress) onSuppress();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [suppressed]);

  if (suppressed) return null;
  return children;
};

const ScopesUpdateBannerWithEntitlements = () => {
  const { isEntitledTo } = useEntitlements();
  // Always mounted so the scopes check runs for every shop. The banner decides
  // whether to surface: entitled shops see the feature-upgrade prompt, and any
  // shop missing a customer-visible scope is prompted regardless.
  return (
    <ScopesUpdateBanner
      isEntitled={isEntitledTo(EntitlementKeys.FB_FILTERS_PROFILE_EXTENDED)}
    />
  );
};

const PreviousLocationTracker = () => {
  usePreviousLocationTracker();
  return null;
};

const history = createAppHistory();

const defaultQueryClientOptions = {
  defaultOptions: {
    queries: {
      retry: false,
      retryOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
  },
};

const queryClient = new QueryClient(defaultQueryClientOptions);

if (ENV !== 'production' && window) {
  window.GlobRequests = Requests;
}

const initialState = {
  appState: window.location.href.split('/')[3],
  appModalObj: null,
  needsRating: false,
  showNotificationsBar: true,
  updatedIntercom: false,
  upsellModal: false,
  user: false,
  shops: [],
  isFetchingShops: false,
};

if (ENV === 'production') {
  history.listen((location) => {
    ReactGA.set({ page: location.pathname });
    ReactGA.pageview(location.pathname);
  });
}

const getSwitcherooIdFromQueryString = () => {
  const currentUrl = new URL(window.location.href);
  const params = currentUrl.searchParams;

  return params.get('swro');
};

// We need store the redirectTo and/or switcherooId value here because we need to save them before the `useEffect` runs,
// as that will only run after the `Redirect` component is mounted. We want to make sure that `redirectTo`
// is always the URL that the user tried to access before being redirected to the login page, and that we don't
// lose the switcherooId if it's present.
let redirectTo = null;
let switcherooId = null;
// Steering to crew is decided once per page load, on the first successful /me.
// Later /me refreshes must never navigate away from unsaved work.
let firstMeHandled = false;
// Set once the page is leaving for crew. Every later /me reply (a second one
// may already be in flight) is then dropped, so no logged-in route mounts.
let leavingForCrew = false;

const parseAndStoreSwitcherooId = () => {
  const currentUrl = new URL(window.location.href);
  const params = currentUrl.searchParams;

  const switchToId = params.get('swro');
  // Not held on an excluded address (see swroToHold).
  if (swroToHold(currentUrl)) {
    switcherooId = switchToId;
    currentUrl.searchParams.delete('swro');
  }
  return switchToId;
};

const getSwitcherooId = () => switcherooId ?? parseAndStoreSwitcherooId();

// Capture swro from the landing address before anything (a login form pushing
// its post-login target, for one) replaces it.
parseAndStoreSwitcherooId();

// Drop a swro that won't be acted on: forget it, as attemptSwitcheroo does once
// it finishes, and remove it from the address bar so a reload or a copied link
// doesn't carry it.
const clearSwitcheroo = () => {
  switcherooId = null;
  redirectTo = null;
  const { pathname, search, hash, state } = history.location;
  const cleaned = withoutSwro(search);
  if (cleaned !== search) {
    history.replace({ pathname, search: cleaned, hash }, state);
  }
};

const RedirectToLogin = () => {
  const path = window.location.pathname;
  const currentUrl = new URL(window.location.href);

  // If we see a switcherooId before redirecting the user, save it to use
  // after the user has been logged in.
  parseAndStoreSwitcherooId();

  if (!redirectTo && path !== '/login') {
    // Without swro: the id is held separately, and a switch that navigates to
    // redirectTo must not reload with swro and ask again.
    redirectTo = `${currentUrl.pathname}${withoutSwro(currentUrl.search)}`;
  }

  return (
    <Redirect to={{ pathname: '/login', search: `?next=${redirectTo}` }} />
  );
};

const RedirectToDefaultRoute = () => {
  const redirectToCopy = redirectTo;
  redirectTo = null;
  // redirectTo comes from the address; a '//...' value would make the router's
  // replaceState throw and blank the app.
  return (
    <Redirect
      to={redirectToCopy ? sameOriginPath(redirectToCopy) : '/dashboard'}
    />
  );
};

export class App extends Component {
  constructor(props) {
    super(props);

    this.state = initialState;
    this.componentDidMount = this.componentDidMount.bind(this);
    this.logOut = this.logOut.bind(this);
    this.attemptSwitcheroo = this.attemptSwitcheroo.bind(this);
    this.setGenericState = this.setGenericState.bind(this);
    this.getUserInfo = this.getUserInfo.bind(this);
    this.changeAppState = this.changeAppState.bind(this);
    this.updateAppModal = this.updateAppModal.bind(this);
    this.checkUserRatings = this.checkUserRatings.bind(this);
    this.checkRevenueForRatings = this.checkRevenueForRatings.bind(this);
    this.updateUserInfo = this.updateUserInfo.bind(this);
    this.updateShops = this.updateShops.bind(this);
    this.handleFirstMe = this.handleFirstMe.bind(this);

    let sentry;
    const hostEnv = getHostEnv(window.location.href);

    if (hostEnv === 'prod') {
      this.state.env = 'prod';
      ReactGA.initialize('UA-119147544-2');
      const sentryAPI = initSentry('production');
      sentry = sentryAPI;
    } else if (hostEnv === 'dev') {
      this.state.env = 'dev';
      const sentryAPI = initSentry('development');
      sentry = sentryAPI;
      ReactGA.initialize('UA-119147544-3');
    } else if (hostEnv === 'local') {
      this.state.env = 'local';
      ReactGA.initialize('UA-119147544-4');
    }

    this.sentry = sentry;
  }

  async componentDidMount() {
    if (window.location.href.includes('/init')) {
      this.props.auth?.clearAccessToken?.();
    }

    await this.props.auth?.refreshAccessToken?.();
  }

  failLegacyHistoryLogin = (accessToken, message) => {
    // A late failure from an older handoff cannot replace a newer session.
    if (
      this.props.auth?.isHistorySession &&
      this.props.auth.accessToken === accessToken
    ) {
      this.setState({ historyEntryError: message });
    }
  };

  completeLegacyHistoryLogin = (user) => {
    if (this.historyBootstrapVersion !== this.props.auth.sessionVersion) {
      queryClient.clear();
      this.historyBootstrapVersion = this.props.auth.sessionVersion;
    }
    return new Promise((resolve) =>
      this.setState(
        {
          user: this.enrichUser(user),
          historyEntryError: null,
          shops: [],
          isFetchingShops: false,
        },
        resolve,
      ),
    );
  };

  componentDidUpdate(prevProps, prevState) {
    // If true, the user just logged in
    if (
      this.props.auth?.isLoggedIn &&
      !prevProps.auth?.isLoggedIn &&
      history.location.pathname !== '/acorn/history'
    ) {
      this.getUserInfo();
    }
  }

  attemptSwitcheroo(switchToId) {
    if (this.props.auth?.isHistorySession) return;
    if (!switchToId) return;

    Requests.postWithCredentials(`/admin/change_shop`, {
      new_shop_id: switchToId,
    })
      .then((result) => {
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.delete('swro');

        if (result?.access_token) {
          // If the cookie swap succeeds, we go to the new URL.
          // redirectTo comes from the address, so keep it on this origin.
          window.location.href = redirectTo
            ? sameOriginHref(redirectTo)
            : currentUrl.toString();
        }
      })
      .finally(() => {
        // Clear the switcherooId and redirectTo from memory
        switcherooId = null;
        redirectTo = null;
      });
  }

  // Carries out planFirstMe. Returns true when the page is leaving for crew;
  // the caller must then skip setState so no logged-in route mounts.
  // adminHost is undefined when the backend predates admin_host.
  handleFirstMe(adminHost) {
    const id = getSwitcherooId();
    const plan = planFirstMe({
      id,
      adminHost,
      isAdminHost: IS_ADMIN_HOST,
      href: window.location.href,
      redirectTo,
    });

    switch (plan.type) {
      case 'redirect':
        window.location.replace(plan.url);
        // Only after replace returns: if it threw, the caller mounts the app
        // and later /me replies must still be handled.
        leavingForCrew = true;
        return true;
      case 'confirm':
        // A link alone must not move an admin into another shop.
        // eslint-disable-next-line no-alert
        if (window.confirm(`Switch into shop ${plan.id}?`)) {
          this.attemptSwitcheroo(plan.id);
        } else {
          clearSwitcheroo();
        }
        return false;
      case 'switch':
        this.attemptSwitcheroo(plan.id);
        return false;
      default:
        // An ignored id (invalid, or on an excluded address) is dropped.
        if (id) clearSwitcheroo();
        return false;
    }
  }

  // Allow lower level components to modify user data.
  updateUserInfo(data) {
    const { user } = this.state;
    // If the user has not been initialized yet, return.
    if (!user) return;

    const newUser = { ...user, ...data };
    this.setState({ user: newUser });
  }

  updateShops() {
    if (this.props.auth?.isHistorySession) return;
    const { user, isFetchingShops, shops } = this.state;
    // If the user has not been initialized yet, we're not logged in, return
    if (!user || isFetchingShops || shops.length) return;

    this.setState(
      {
        isFetchingShops: true,
      },
      () => {
        Requests.get('/admin/get_all_shops?limit=30').then(
          function (result) {
            if (result && result.shops) {
              this.setState({
                isFetchingShops: false,
                shops: result.shops,
              });
            }
          }.bind(this),
        );
      },
    );
  }

  checkRevenueForRatings() {
    Requests.get('/shop/has_revenue').then(
      function (result) {
        if (result && result.success) {
          if (result.has_revenue) {
            // If they have generated revenue within
            // 30 days of install, send activated event
            // This is allowed to fire multiple times per user
            // since we don't track firing on the backend
            // TODO: Track activation events on the backend
            // and don't fire multiple times

            const thirty_days = new Date();
            thirty_days.setDate(thirty_days.getDate() - 30);
            const installed_at_date = new Date(this.state.user.installed_at);
            if (installed_at_date > thirty_days) {
              Events.track('Account Activated - 30 Days');
            }
          }
          this.setState(
            {
              revenueEarned: result.has_revenue,
            },
            () => {
              if (!this.state.user) return;
              let usage = 0;
              let percentageUsed = 0;
              let allowed = 0;
              if (this.state.user) {
                if (this.state.user.texts_sent_this_month) {
                  usage = this.state.user.texts_sent_this_month;
                }
                if (
                  this.state.user.billing_period_record &&
                  this.state.user.billing_period_record.number_of_texts
                ) {
                  usage = this.state.user.billing_period_record.number_of_texts;
                }
                if (
                  this.state.user.plan &&
                  this.state.user.plan.monthly_texts_allowed
                ) {
                  allowed = this.state.user.plan.monthly_texts_allowed;
                  percentageUsed = Math.floor((usage / allowed) * 100);
                }
                if (
                  this.state.user.billing_period_record &&
                  this.state.user.billing_period_record.number_of_texts_allowed
                ) {
                  allowed =
                    this.state.user.billing_period_record
                      .number_of_texts_allowed;
                  percentageUsed = Math.floor((usage / allowed) * 100);
                }
              }
              let daysRemainingInPeriod = 0;
              let daysInPeriod = 0;
              if (
                this.state.user &&
                this.state.user.billing_period_record &&
                this.state.user.billing_period_record.billing_period_end_time &&
                this.state.user.billing_period_record.billing_period_start_time
              ) {
                daysInPeriod = Math.floor(
                  (new Date(
                    this.state.user.billing_period_record.billing_period_end_time,
                  ) -
                    new Date(
                      this.state.user.billing_period_record.billing_period_start_time,
                    )) /
                    (1000 * 3600 * 24),
                );
                daysRemainingInPeriod = Math.floor(
                  (new Date(
                    this.state.user.billing_period_record.billing_period_end_time,
                  ) -
                    new Date()) /
                    (1000 * 3600 * 24),
                );
              }
              if (
                this.state.user &&
                !this.state.user.is_admin &&
                this.state.user.plan &&
                this.state.user.free_trial &&
                !this.state.user.free_trial.active &&
                ((percentageUsed >= 50 &&
                  this.state.user.plan.price === '$0.00') ||
                  (percentageUsed >= 90 && daysRemainingInPeriod >= 5) ||
                  (percentageUsed >= 80 && daysRemainingInPeriod >= 10) ||
                  (percentageUsed >= 70 && daysRemainingInPeriod >= 15))
              ) {
                this.setState({
                  upsellModal: true,
                  percentageOfCreditsUsed: percentageUsed,
                  daysRemainingInPeriod,
                });
              } else {
                this.checkUserRatings();
              }
            },
          );
        }
      }.bind(this),
    );
  }

  checkUserRatings() {
    // if user has a certain amount of revenue and hasn't left a review ever or in the past 1-2 months
    if (!this.state.user) return;
    const path = '/postscript_rating';
    Requests.get(path).then(
      function (result) {
        if (result) {
          let needsRating = false;
          const ratings = result.ratings ? result.ratings : [];
          let latestRating = null;
          let leftReview = false;
          let leftFeedback = false;
          if (ratings.length > 0) {
            ratings.forEach((r) => {
              if (
                r.app_store_review ||
                (this.state.user &&
                  this.state.user.data &&
                  this.state.user.data.shopify_review)
              )
                leftReview = true;
              if (r.feedback && r.feedback.length > 0) leftFeedback = true;
              const createdDate = new Date(r.created_at);
              if (createdDate && (createdDate > latestRating || !latestRating))
                latestRating = createdDate;
            });
            if (
              new Date() - latestRating > 30 * 24 * 60 * 60 * 1000 &&
              !leftReview
            )
              needsRating = true;
          } else {
            needsRating = true;
          }
          if (!this.state.revenueEarned) needsRating = false;
          this.setState({
            needsRating,
            ratings,
          });
        }
      }.bind(this),
    );
  }

  setGenericState(obj) {
    this.setState(obj);
  }

  changeAppState(name) {
    this.setState({
      appState: name,
    });
  }

  updateAppModal(modalObj) {
    this.setState({
      appModalObj: modalObj,
    });
  }

  getUserInfo(callback, refetchShops = true) {
    if (this.props.auth?.isHistorySession) {
      const { accessToken, sessionVersion } = this.props.auth;
      if (!accessToken) return;
      return loadLegacyHistoryUser(accessToken).then(
        (user) => {
          if (
            this.props.auth.accessToken !== accessToken ||
            this.props.auth.sessionVersion !== sessionVersion
          )
            return;
          return this.completeLegacyHistoryLogin(user).then(() => callback?.());
        },
        (error) => {
          if (
            this.props.auth.accessToken === accessToken &&
            this.props.auth.sessionVersion === sessionVersion
          ) {
            this.props.auth.failHistoryBootstrap(accessToken, error);
          }
        },
      );
    }
    if (this.props.auth?.isLoggedIn) {
      Requests.get('/me')
        .then((result) => {
          if (leavingForCrew) return null;
          // A failed /me decides nothing: swro and the held id stay, and the
          // next successful /me on the page (usually after a reload) decides.
          if (!firstMeHandled && result && result.data) {
            firstMeHandled = true;
            try {
              // Leaving for crew: return null so setState is skipped.
              if (this.handleFirstMe(result.data.admin_host)) {
                return null;
              }
            } catch (error) {
              // Never leave the app blank: fall through to the normal path.
              console.error('Steering on the first /me failed:', error);
            }
          }
          if (result && result.data) {
            return result;
          }

          return null;
        })
        .then(
          function (result) {
            if (result && result.data) {
              if (
                this.state.user &&
                !this.state.user.has_synced &&
                result.data.has_synced == true &&
                result.data.has_onboarded
              ) {
                this.updateAppModal({
                  header: 'Sync Finished!',
                  body: "Your shop's customer and order data have been synced to Postscript. You're all set to create campaigns with granular segmentation based on your subscribers' order history.",
                  button: 'Got It',
                });
              }
              if (result.data.shop_statistics)
                result.data.shop_statistics = null;
              if (result.data.username) {
                Events.initialize(result.data.username);
                // Full Story Identification
                // Ignore admins
                const metadata = result.data;
                metadata.displayName = result.data.shop_name;

                // GTM Data Layer
                if (window.dataLayer) {
                  window.dataLayer.push(metadata);
                  window.dataLayer.push({
                    event: 'User Data Loaded',
                  });
                }
              }

              // Convert date types.
              if (result.data.free_trial && result.data.free_trial.end_date) {
                result.data.free_trial.end_date = new Date(
                  result.data.free_trial.end_date,
                );
              }
              if (!result.data.short_link_domain) {
                result.data.short_link_domain = 'pscr.pt';
              }

              this.setState(
                {
                  user: this.enrichUser(result.data),
                },
                () => {
                  if (refetchShops) this.updateShops();

                  if (callback) callback();
                  if (typeof this.state.revenueEarned !== 'boolean')
                    this.checkRevenueForRatings();
                },
              );
              if (
                result.data.announcement &&
                result.data.announcement.announcement
              ) {
                this.updateAppModal({
                  header: result.data.announcement.announcement.headline,
                  body: result.data.announcement.announcement.body,
                  button: result.data.announcement.announcement.cta_text,
                  path: result.data.announcement.announcement.cta_path,
                  media_url:
                    result.data.announcement.announcement.cta_media_url,
                  announcement_id: result.data.announcement.id,
                });
              }
            }
          }.bind(this),
        );
    }
  }

  /**
   * Determines whether a user can provider feedback, based on plan
   * price
   */
  userCanProvideIdeas(user, minimumIdeasPrice = 100) {
    if (user && user.plan && user.plan.price) {
      const planPrice = user.plan.price;
      const parsedPrice = parseFloat(planPrice.replace('$', ''));
      return parsedPrice >= minimumIdeasPrice;
    }

    return false;
  }

  /**
   * Add derived attributes to the user object
   */
  enrichUser(user) {
    return {
      ...user,
      canProvideIdeas: this.userCanProvideIdeas(user),
    };
  }

  logOut() {
    if (!this.props.auth?.isHistorySession) Events.track('Logged Out');
    this.props.auth?.logOut().then(
      function (ended) {
        if (!ended) return;
        this.setState({ shops: [] });
        window.location.replace('/login');
      }.bind(this),
    );
  }

  render() {
    const { user, shops, isFetchingShops } = this.state;

    if (history.location.pathname === '/acorn/history') {
      return (
        <Router history={history}>
          <Suspense fallback={<Loading />}>
            <LegacyHistoryLogin
              onAuthenticated={this.completeLegacyHistoryLogin}
              onFailed={this.failLegacyHistoryLogin}
            />
          </Suspense>
        </Router>
      );
    }

    if (this.props.auth?.isHistorySession && this.state.historyEntryError) {
      return <LegacyHistoryExpired entryError={this.state.historyEntryError} />;
    }

    // Avoid flashing the wrong UI until the user is _fully_ logged in
    if (this.props.auth?.isLoading) {
      return null;
    }

    if (this.props.auth?.isHistorySession && !this.props.auth?.isLoggedIn) {
      return (
        <LegacyHistoryExpired
          isLogoutPending={this.props.auth.historyLogoutPending}
          isLogoutInFlight={this.props.auth.historyLogoutInFlight}
          onRetry={
            this.props.auth.historyLogoutPending
              ? () => this.props.auth.logOut()
              : this.props.auth.historyResumeError
              ? () => this.props.auth.refreshAccessToken()
              : undefined
          }
        />
      );
    }

    return (
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={base}>
          <HistoryContext.Provider value={history}>
            <SentryContext.Provider value={this.sentry}>
              <EntitlementsProvider>
                <Router history={history}>
                  <PreviousLocationTracker />
                  <ToastContainer />
                  {this.props.auth?.isLoggedIn ? (
                    this.state.user ? (
                      // Logged In View
                      !this.state.user.has_onboarded &&
                      !history.location.pathname.includes('onboarding') &&
                      // Hack: avoid redirecting to onboarding if user is visiting PSPay checkout page
                      !history.location.pathname.includes('pspay-customer') ? (
                        <Redirect to="/onboarding" />
                      ) : (
                        <GlobalAuthenticatedContexts
                          user={user}
                          shops={shops}
                          isFetchingShops={isFetchingShops}
                          getUserInfo={this.getUserInfo}
                          updateUserInfo={this.updateUserInfo}
                          updateShops={this.updateShops}
                        >
                          {this.state.needsRating &&
                          this.state.user &&
                          !this.state.user.is_admin ? (
                            <DelightedRatingComponent user={this.state.user} />
                          ) : null}
                          {this.state.appModalObj ? (
                            <AppModal
                              modalObj={this.state.appModalObj}
                              updateAppModal={this.updateAppModal}
                            />
                          ) : null}
                          {this.state.upsellModal ? (
                            <UpsellModalGate
                              onSuppress={() => {
                                this.setState({ upsellModal: false });
                                this.checkUserRatings();
                              }}
                            >
                              <UpsellModal
                                user={this.state.user}
                                closeModal={() => {
                                  this.setState({ upsellModal: false });
                                }}
                                percentageUsed={
                                  this.state.percentageOfCreditsUsed
                                }
                                daysRemainingInPeriod={
                                  this.state.daysRemainingInPeriod
                                }
                              />
                            </UpsellModalGate>
                          ) : null}
                          {!this.props.auth?.isHistorySession && (
                            <>
                              <ShopData />
                              <OnboardingStatusBanner />
                              <DataSyncingBanner user={this.state.user} />
                              <CallForwardingBanner />
                              <LegacyPastDueStatusBanner />
                              <RacApprovedConfirmation />
                              <BillingBanners />
                              <ScopesUpdateBannerWithEntitlements />
                              <TFNVerificationStatusBanner />
                              <TFNInvalidationBanner />
                              <KlaviyoOAuthMigrationBanner />
                              <KlaviyoScopesUpdateBanner />
                            </>
                          )}
                          {window.location.href.split('/').length < 5 &&
                          window.location.href.split('/')[3].length < 1 ? (
                            <Redirect from="/" to="/dashboard" />
                          ) : null}
                          <Suspense
                            fallback={
                              <AppShell
                                appState={this.state.appState}
                                changeAppState={this.changeAppState}
                                getUserInfo={this.getUserInfo}
                                user={this.state.user}
                                shops={shops}
                                logOut={this.logOut}
                                inSuspense
                              />
                            }
                          >
                            <Switch>
                              {/* Routes that skip AppShell */}
                              <Route
                                exact
                                key="redirect-page"
                                path="/pspay-customer/:uniqueKey"
                                render={(props) => <RedirectPage {...props} />}
                              />
                              <Route path="/shopify/init" component={AppInit} />
                              <Route
                                key="onboarding"
                                path="/onboarding"
                                render={() => (
                                  <LabsFeatureContext.Consumer>
                                    {({ hasInitialized }) => {
                                      if (!hasInitialized) {
                                        return null;
                                      }
                                      return (
                                        <Route
                                          path="/onboarding"
                                          component={OnboardingRoutes}
                                        />
                                      );
                                    }}
                                  </LabsFeatureContext.Consumer>
                                )}
                              />
                              <Route
                                key="zendesk-oauth"
                                path="/integrations/zendesk/oauth_authorize"
                                component={() => {
                                  window.location.href = `https://api.postscript.io/integrations/zendesk/oauth_authorize?${window.location.search.substr(
                                    1,
                                  )}`;
                                  return null;
                                }}
                              />
                              <Route
                                key="shopper-playground"
                                path="/shopper-playground"
                                component={ShopperPlaygroundPage}
                              />

                              {/* All other routes share a single AppShell */}
                              <Route
                                render={({ location }) => (
                                  <AppShell
                                    appState={this.state.appState}
                                    changeAppState={this.changeAppState}
                                    getUserInfo={this.getUserInfo}
                                    user={this.state.user}
                                    shops={shops}
                                    logOut={this.logOut}
                                    location={location}
                                  >
                                    <Switch location={location}>
                                      <Route
                                        key="sms-sales-merchant"
                                        path="/sms-sales"
                                        component={SMSSalesMerchantRoutes}
                                      />
                                      <Route
                                        key="subscriber-list-uploads"
                                        path="/subscriber-list-uploads"
                                        component={SubscriberListUploadsRoutes}
                                      />
                                      <Route
                                        key="subscriber-property-uploads"
                                        path="/subscriber-property-uploads"
                                        component={
                                          SubscriberPropertyUploadsRoutes
                                        }
                                      />
                                      <Route
                                        key="bulk-subscriber-operations"
                                        path="/bulk-subscriber-operations"
                                        component={
                                          BulkSubscriberOperationsRoutes
                                        }
                                      />
                                      <Route
                                        key="sms-sales-looker-dashboard"
                                        path="/sms-sales-dashboard"
                                        render={() => (
                                          <LookerDashboard id={230} />
                                        )}
                                      />
                                      <Route
                                        key="test-omni-dashboard"
                                        path="/omni"
                                        render={() => (
                                          <OmniDashboards
                                            title="Omni Dashboards"
                                            featureKey={OMNI_SANDBOX}
                                            adminOnly
                                          />
                                        )}
                                      />
                                      <Route
                                        key="shopper-trends"
                                        path="/data-insights/shopper"
                                        render={() => (
                                          <LabsFeatureContext.Consumer>
                                            {({ hasInitialized }) => {
                                              if (!hasInitialized) {
                                                return null;
                                              }
                                              return (
                                                <ShopperStatusProvider>
                                                  <AnalyticsShopperTrendsView />
                                                </ShopperStatusProvider>
                                              );
                                            }}
                                          </LabsFeatureContext.Consumer>
                                        )}
                                      />
                                      <Route
                                        key="trends"
                                        path="/trends"
                                        render={() => (
                                          <RestrictedPage
                                            permission="analytics_read"
                                            pageTitle="Trends"
                                          >
                                            <OmniReportingGate
                                              unavailableFallback={
                                                <Redirect to="/dashboard" />
                                              }
                                            >
                                              <OmniDashboards
                                                title="Trends"
                                                featureKey={OMNI_TRENDS}
                                              />
                                            </OmniReportingGate>
                                          </RestrictedPage>
                                        )}
                                      />
                                      <Route
                                        key="admin-list-management"
                                        path="/admin/list-management"
                                        component={SubscriberListsRoutes}
                                      />
                                      <Route
                                        key="dashboard"
                                        path="/dashboard"
                                        render={() => (
                                          <PopupsProvider>
                                            <ShopperStatusProvider>
                                              <DashboardViewEntry
                                                changeAppState={
                                                  this.changeAppState
                                                }
                                                getUserInfo={this.getUserInfo}
                                                user={this.state.user}
                                                updateAppModal={
                                                  this.updateAppModal
                                                }
                                                showNotificationsBar={
                                                  this.state
                                                    .showNotificationsBar
                                                }
                                                closeNotificationsBar={() => {
                                                  this.setState({
                                                    showNotificationsBar: false,
                                                  });
                                                }}
                                              />
                                            </ShopperStatusProvider>
                                          </PopupsProvider>
                                        )}
                                      />
                                      <Route
                                        key="campaigns"
                                        path="/campaigns"
                                        render={(props) => (
                                          <CampaignsView
                                            {...props}
                                            user={this.state.user}
                                            updateAppModal={this.updateAppModal}
                                            changeAppState={this.changeAppState}
                                          />
                                        )}
                                      />
                                      {/* v2 segment builder; must precede the
                                            /segments routes. */}
                                      <Route
                                        key="segments-v2"
                                        path="/segments/v2"
                                        component={SegmentsV2Routes}
                                      />
                                      <Route
                                        key="segment-subscriber-view"
                                        path="/segments/:segmentId/subscribers"
                                        render={(props) => (
                                          <SegmentSubscribersView {...props} />
                                        )}
                                      />
                                      <Route
                                        key="segments"
                                        path="/segments"
                                        render={() => (
                                          <SegmentView
                                            changeAppState={this.changeAppState}
                                            user={this.state.user}
                                            updateAppModal={this.updateAppModal}
                                          />
                                        )}
                                      />
                                      <Route
                                        key="email-templates"
                                        path="/email-templates"
                                        component={EmailTemplatesRoutes}
                                      />
                                      <Route exact path="/reports">
                                        <Redirect to="/account/reports" />
                                      </Route>
                                      <Route
                                        key="automations"
                                        path="/automations"
                                        render={(props) => (
                                          <AutomationsRoutes
                                            user={this.state.user}
                                            updateAppModal={this.updateAppModal}
                                            changeAppState={this.changeAppState}
                                            {...props}
                                          />
                                        )}
                                      />
                                      <Route
                                        key="keywords"
                                        path="/keywords"
                                        render={() => (
                                          <RouteGuard
                                            entitlements={[
                                              EntitlementKeys.ACQUISITION_KEYWORDS_VIEW,
                                            ]}
                                          >
                                            <UsageBillingContext.Consumer>
                                              {(usageBillingData) => {
                                                const {
                                                  hasPackageFeature,
                                                  currentPlan,
                                                } = usageBillingData;
                                                if (
                                                  currentPlan &&
                                                  !hasPackageFeature({
                                                    featureKey:
                                                      FEATURE_KEYS.keywords,
                                                    currentPlan,
                                                  })
                                                ) {
                                                  return (
                                                    <Redirect to="/dashboard" />
                                                  );
                                                }
                                                return (
                                                  <KeywordsView
                                                    user={this.state.user}
                                                    updateAppModal={
                                                      this.updateAppModal
                                                    }
                                                    changeAppState={
                                                      this.changeAppState
                                                    }
                                                    usageBillingData={
                                                      usageBillingData
                                                    }
                                                  />
                                                );
                                              }}
                                            </UsageBillingContext.Consumer>
                                          </RouteGuard>
                                        )}
                                      />
                                      <Route
                                        key="responses"
                                        path="/responses/:id?"
                                        render={(props) => (
                                          <ResponsesView
                                            {...props}
                                            user={this.state.user}
                                            updateAppModal={this.updateAppModal}
                                            changeAppState={this.changeAppState}
                                            getUserInfo={this.getUserInfo}
                                          />
                                        )}
                                      />
                                      <Route
                                        key="shopper-conversations"
                                        path="/conversations/:id?"
                                        render={(props) => (
                                          <ShopperStatusProvider>
                                            <ConversationsView
                                              {...props}
                                              user={this.state.user}
                                              updateAppModal={
                                                this.updateAppModal
                                              }
                                              changeAppState={
                                                this.changeAppState
                                              }
                                              getUserInfo={this.getUserInfo}
                                            />
                                          </ShopperStatusProvider>
                                        )}
                                      />
                                      <Route
                                        key="pspay"
                                        path="/pspay"
                                        render={(props) => (
                                          <PsPayProvider>
                                            <PsPayRoutes {...props} />
                                          </PsPayProvider>
                                        )}
                                      />
                                      <Route
                                        key="grow"
                                        path="/grow"
                                        render={() => (
                                          <RouteGuard
                                            entitlements={[
                                              EntitlementKeys.ACQUISITION_LIST_GROWTH_VIEW,
                                            ]}
                                          >
                                            <GrowListView
                                              user={this.state.user}
                                              updateAppModal={
                                                this.updateAppModal
                                              }
                                              changeAppState={
                                                this.changeAppState
                                              }
                                            />
                                          </RouteGuard>
                                        )}
                                      />
                                      <Route
                                        key="data-insights"
                                        path="/data-insights"
                                        component={AnalyticsRoutes}
                                      />
                                      <Route
                                        key="flows"
                                        path="/flows"
                                        component={FlowsRoutes}
                                      />
                                      <Route
                                        key="legacy"
                                        path="/legacy"
                                        component={LegacyRoutes}
                                      />
                                      <Route
                                        key="self-migrate-usage-billing-plans"
                                        path="/billing/switch-to-usage"
                                        component={Plans}
                                      />
                                      <Route
                                        key="usage-billing"
                                        path="/billing"
                                        component={BillingRoutes}
                                      />
                                      <Route
                                        key="brand"
                                        path="/brand"
                                        render={() => (
                                          <ShopperStatusProvider>
                                            <BrandRoutes />
                                          </ShopperStatusProvider>
                                        )}
                                      />
                                      <Route
                                        key="cashback"
                                        path="/cashback"
                                        component={CashbackRoutes}
                                      />
                                      <Route
                                        key="user-profile"
                                        path="/profile"
                                        component={Profile}
                                      />
                                      <Route
                                        key="account"
                                        path="/account"
                                        render={(props) => (
                                          <AccountView
                                            location={props.location}
                                            user={this.state.user}
                                            getUserInfo={this.getUserInfo}
                                          />
                                        )}
                                      />
                                      {this.state.user.canProvideIdeas && (
                                        <Route
                                          key="ideas"
                                          exact
                                          path="/ideas"
                                          component={IdeasView}
                                        />
                                      )}
                                      <Route
                                        key="checkout"
                                        path="/checkout"
                                        render={({ match }) => (
                                          <RouteGuard
                                            entitlements={[
                                              EntitlementKeys.ACQUISITION_CHECKOUT_VIEW,
                                            ]}
                                          >
                                            <CheckoutSettingsView
                                              user={this.state.user}
                                              getUserInfo={this.getUserInfo}
                                              changeAppState={
                                                this.changeAppState
                                              }
                                              updateAppModal={
                                                this.updateAppModal
                                              }
                                              match={match}
                                            />
                                          </RouteGuard>
                                        )}
                                      />
                                      <Route
                                        key="gorgias-integration"
                                        path="/integrations/gorgias"
                                        component={GorgiasIntegrationV2}
                                      />
                                      <Route
                                        key="fondue"
                                        path="/fondue"
                                        render={() => (
                                          <RouteGuard
                                            entitlements={[
                                              'integrations::fondue::setup',
                                            ]}
                                          >
                                            <FondueLanding />
                                          </RouteGuard>
                                        )}
                                      />
                                      <Route
                                        key="integrations"
                                        path="/integrations"
                                        render={() => (
                                          <RouteGuard
                                            entitlements={[
                                              'integrations::browse',
                                            ]}
                                          >
                                            <IntegrationsView
                                              user={this.state.user}
                                              getUserInfo={this.getUserInfo}
                                              changeAppState={
                                                this.changeAppState
                                              }
                                            />
                                          </RouteGuard>
                                        )}
                                      />
                                      <Route
                                        key="notifications"
                                        path="/notifications"
                                        render={() => (
                                          <NotificationsView
                                            user={this.state.user}
                                            getUserInfo={this.getUserInfo}
                                            changeAppState={this.changeAppState}
                                          />
                                        )}
                                      />
                                      <Route
                                        key="sudo"
                                        path="/account-overview/sudo"
                                        render={(props) => (
                                          <SuperuserView match={props.match} />
                                        )}
                                      />
                                      <Route
                                        key="account-overview"
                                        path="/account-overview"
                                        render={() => (
                                          <AccountReviewView
                                            user={this.state.user}
                                            ratings={this.state.ratings}
                                            getUserInfo={this.getUserInfo}
                                            updateUserInfo={this.updateUserInfo}
                                            changeAppState={this.changeAppState}
                                          />
                                        )}
                                      />
                                      <Route
                                        key="ai-configuration"
                                        path="/ai-configuration"
                                        component={AIProductConfiguration}
                                      />
                                      <Route
                                        key="legacy-popups"
                                        path={LEGACY_POPUPS_PATH}
                                        render={() => (
                                          <RouteGuard
                                            entitlements={[
                                              EntitlementKeys.ACQUISITION_POPUPS_VIEW,
                                            ]}
                                          >
                                            <PopupRoutes />
                                          </RouteGuard>
                                        )}
                                      />
                                      <Route
                                        key="block-popups-redirect"
                                        path={LEGACY_BLOCK_POPUPS_LIST_PATH}
                                        render={renderPrefixRedirect(
                                          LEGACY_BLOCK_POPUPS_LIST_PATH,
                                          BLOCK_POPUP_PATHS.LIST,
                                        )}
                                      />
                                      <Route
                                        key="popups"
                                        path={BLOCK_POPUP_PATHS.LIST}
                                        render={() => (
                                          <RouteGuard
                                            entitlements={[
                                              EntitlementKeys.ACQUISITION_POPUPS_VIEW,
                                            ]}
                                          >
                                            <PopupBlockRoutes />
                                          </RouteGuard>
                                        )}
                                      />
                                      <Route
                                        key="back-in-stock"
                                        path={ROUTE_BACK_IN_STOCK}
                                        render={() => (
                                          <RouteGuard
                                            entitlements={[
                                              EntitlementKeys.ACQUISITION_POPUPS_VIEW,
                                            ]}
                                          >
                                            <BackInStockRoutes />
                                          </RouteGuard>
                                        )}
                                      />
                                      <Route
                                        key="landing-pages"
                                        path={ROUTE_LANDING_PAGES}
                                        render={() => (
                                          <RouteGuard
                                            entitlements={[
                                              EntitlementKeys.ACQUISITION_LANDING_PAGES_VIEW,
                                            ]}
                                          >
                                            <LandingPagesRoutes />
                                          </RouteGuard>
                                        )}
                                      />
                                      <Route
                                        key="embedded-forms"
                                        path={ROUTE_EMBEDDED_FORMS}
                                        render={() => (
                                          <RouteGuard
                                            entitlements={[
                                              EntitlementKeys.ACQUISITION_EMBEDDED_FORMS_VIEW,
                                            ]}
                                          >
                                            <EmbeddedFormsRoutes />
                                          </RouteGuard>
                                        )}
                                      />
                                      <Route
                                        key="targeting-profiles"
                                        path={ROUTE_SAVED_TARGETING_PROFILES}
                                        render={() => (
                                          <TargetingProfilesRoutes />
                                        )}
                                      />
                                      <Route
                                        key="customers"
                                        path="/customers/:id?"
                                        render={(props) => (
                                          <ContactView
                                            {...props}
                                            changeAppState={this.changeAppState}
                                            user={this.state.user}
                                            updateAppModal={this.updateAppModal}
                                            queryClient={queryClient}
                                          />
                                        )}
                                      />
                                      <Route
                                        key="subscribers"
                                        path="/subscribers/:id?"
                                        render={(props) => (
                                          <ShopperStatusProvider>
                                            <ContactView
                                              {...props}
                                              changeAppState={
                                                this.changeAppState
                                              }
                                              user={this.state.user}
                                              updateAppModal={
                                                this.updateAppModal
                                              }
                                              queryClient={queryClient}
                                            />
                                          </ShopperStatusProvider>
                                        )}
                                      />
                                      <Route
                                        key="referrals"
                                        path="/referrals"
                                        render={() => (
                                          <ReferralsProvider>
                                            <ReferralsView />
                                          </ReferralsProvider>
                                        )}
                                      />
                                      <Route
                                        key="admin"
                                        path="/admin"
                                        component={AdminRoutes}
                                      />
                                      <Route
                                        key="shopify-auth"
                                        path="/shopify/auth"
                                        render={() => (
                                          <AppAuth
                                            loggedIn
                                            getUserInfo={this.getUserInfo}
                                          />
                                        )}
                                      />
                                      <Route
                                        key="run-template"
                                        path="/t/:id"
                                        render={(props) => (
                                          <RunTemplateView
                                            id={props.match.params.id}
                                          />
                                        )}
                                      />
                                      <Route
                                        key="sales"
                                        path={SALES_ROUTE_PREFIX}
                                        component={SalesRoutes}
                                      />
                                      <RedirectToDefaultRoute />
                                    </Switch>
                                  </AppShell>
                                )}
                              />
                            </Switch>
                          </Suspense>
                        </GlobalAuthenticatedContexts>
                      )
                    ) : null
                  ) : // Logged Out View
                  this.props.auth?.isLoggedIn == false ? (
                    <Suspense fallback={<Loading />}>
                      <Switch>
                        <Route
                          path="/pspay-customer/:uniqueKey"
                          key={162}
                          render={(props) => (
                            <LegacyGlobalNotificationsProvider>
                              <LegacyGlobalBannerList />
                              <RedirectPage {...props} />
                            </LegacyGlobalNotificationsProvider>
                          )}
                        />
                        <Route
                          path="/login"
                          render={(props) => (
                            <LoginUserShopify
                              changeState={this.setGenericState}
                            />
                          )}
                        />
                        <Route
                          path="/login_email"
                          render={(props) => <LoginForm />}
                        />
                        <Route
                          path="/new_password"
                          render={(props) => (
                            <ResetForgottenPassword
                              changeState={this.setGenericState}
                            />
                          )}
                        />
                        <Route path="/shopify/init" component={AppInit} />
                        <Route
                          path="/shopify/auth"
                          render={(props) => (
                            <AppAuth
                              changeState={this.setGenericState}
                              getUserInfo={this.getUserInfo}
                            />
                          )}
                        />
                        <Route
                          path="/register_store"
                          render={() => (
                            <RegisterForm changeState={this.setGenericState} />
                          )}
                        />
                        <Route
                          path="/ref"
                          render={(props) => (
                            <ReferralRedirect
                              match={props.match}
                              changeState={this.setGenericState}
                            />
                          )}
                        />
                        <Route
                          path="/reset"
                          render={(props) => (
                            <ResetPasswordInvisible
                              getUserInfo={this.getUserInfo}
                              changeState={this.setGenericState}
                            />
                          )}
                        />
                        <Route
                          path="/request_reset"
                          render={(props) => <ResetPasswordRequest />}
                        />

                        <RedirectToLogin />
                      </Switch>
                    </Suspense>
                  ) : null}
                </Router>
              </EntitlementsProvider>
            </SentryContext.Provider>
          </HistoryContext.Provider>
        </ThemeProvider>
        {ENV !== 'production' && <ReactQueryDevtools />}
      </QueryClientProvider>
    );
  }
}

export default withAuth(feedbackLoopRedirect(App));
export { history, UserContext };
